export enum FunctionKey {
  HomeList = 'crm:home:list',

  MessagesMass = 'crm:of:messages:mass',
  MessagesOnlineFans = 'crm:of:messages:onlineFans',

  AnalyticsCreatorOverviewExport = 'crm:analytics:creator:overview:export',
  AnalyticsCreatorOverviewReassign = 'crm:analytics:creator:overview:reassign',
  AnalyticsCreatorOverviewRemove = 'crm:analytics:creator:overview:remove',

  GrowthTagsEdit = 'crm:growth:tags:edit',
  GrowthTagsTurn = 'crm:growth:tags:turn',
  GrowthFollowScan = 'crm:growth:follow:scan',

  GrowthScriptsEditTags = 'crm:growth:scripts:editTags',
  GrowthScriptsAdd = 'crm:growth:scripts:add',
  GrowthScriptsEditScripts = 'crm:growth:scripts:editScripts',
  GrowthScriptsDelete = 'crm:growth:scripts:delete',

  GrowthProfile = 'crm:growth:profile:details',
  GrowthProfileCreate = 'crm:growth:profile:create',
  GrowthProfileCampaign = 'crm:growth:profile:campaign',
  GrowthProfileAddFans = 'crm:growth:profile:addFans',

  GrowthTrialLinksCreate = 'crm:growth:trialLinks:create',
  GrowthTrialLinksDetail = 'crm:growth:trialLinks:detail',
  GrowthTrialLinksPromotion = 'crm:growth:trialLinks:promotion',
  GrowthTrialLinksEditSource = 'crm:growth:trialLinks:editSource',
  GrowthTrialLinksEditList = 'crm:growth:trialLinks:editList',
  GrowthTrackingLinksCreate = 'crm:growth:trackingLinks:create',
  GrowthTrackingLinksDetail = 'crm:growth:trackingLinks:detail',
  GrowthTrackingLinksEditSource = 'crm:growth:trackingLinks:editSource',
  GrowthTrackingLinksEditList = 'crm:growth:trackingLinks:editList',
  GrowthTrackingLinksAddPromo = 'crm:growth:trackingLinks:addPromo',
  GrowthTrackingLinksExport = 'crm:growth:trackingLinks:export',

  GrowthSensitiveWordsImport = 'crm:growth:sensitiveWords:import',
  GrowthSensitiveWordsExport = 'crm:growth:sensitiveWords:export',
  GrowthSensitiveWordsAddWord = 'crm:growth:sensitiveWords:addWord',
  GrowthSensitiveWordsEditWord = 'crm:growth:sensitiveWords:editWord',
  GrowthSensitiveWordsDelete = 'crm:growth:sensitiveWords:delete',

  AnalyticsCreatorPerformanceList = 'crm:analytics:creator:performance:list',
  AnalyticsCreatorOverviewList = 'crm:analytics:creator:overview:list',
  AnalyticsChatterOverviewList = 'crm:analytics:chatter:overview:list',
  AnalyticsChatterPerformanceList = 'crm:analytics:chatter:performance:list',
  AnalyticsFansRList = 'crm:analytics:fansR:list',

  GrowthTagsList = 'crm:growth:tags:list',
  GrowthFollowList = 'crm:growth:follow:list',
  GrowthScriptsList = 'crm:growth:scripts:list',
  GrowthProfileList = 'crm:growth:profile:list',
  GrowthTrialListList = 'crm:growth:trialLinks:list',
  GrowthTrackingListList = 'crm:growth:trackingLinks:list',

  CreatorsManageAddCreator = 'crm:creators:manage:addCreator',
  CreatorsManageEditCreator = 'crm:creators:manage:editCreator',
  CreatorsManageEnableDisableCreator = 'crm:creators:manage:ena_disaCreator',
  CreatorsManageDeleteCreator = 'crm:creators:manage:deleteCreator',
  CreatorsManageAddGroup = 'crm:creators:manage:addGroup',
  CreatorsManageEditGroup = 'crm:creators:manage:editGroup',
  CreatorsManageDeleteGroup = 'crm:creators:manage:deleteGroup',

  EmployeesManageAddEmployee = 'crm:employees:manage:addEmployee',
  EmployeesManageEditEmployee = 'crm:employees:manage:editEmployee',
  EmployeesManageDeleteEmployee = 'crm:employees:manage:deleteEmployee',
  EmployeesManageEnableDisableEmployee = 'crm:employees:manage:ena_disaEmployee',
  EmployeesManageResetPassword = 'crm:employees:manage:resetPassword',
  EmployeesManageAssignCreators = 'crm:employees:manage:assignCreators',
  EmployeesManageSetupRole = 'crm:employees:manage:setupRole',
  EmployeesManageAddGroup = 'crm:employees:manage:addGroup',
  EmployeesManageEditGroup = 'crm:employees:manage:editGroup',
  EmployeesManageDeleteGroup = 'crm:employees:manage:deleteGroup',

  ShiftScheduleAdd = 'crm:shift:schedule:add',
  ShiftScheduleEdit = 'crm:shift:schedule:edit',
  ShiftScheduleDelete = 'crm:shift:schedule:delete',
  ShiftScheduleSettings = 'crm:shift:schedule:settings',

  ShiftRecordsEdit = 'crm:shift:records:edit',
  ShiftRecordsReassign = 'crm:shift:records:reassign',
  ShiftRecordsRemove = 'crm:shift:records:remove',

  SettingsRoleAdd = 'crm:settings:role:add',
  SettingsRoleEdit = 'crm:settings:role:edit',
  SettingsRoleDelete = 'crm:settings:role:delete',
  SettingsRoleEnableDisable = 'crm:settings:role:ena_disaRole',
  SettingsRoleAndSetPermissions = 'crm:settings:role:setPermissions',

  GrowthSensitiveWordsList = 'crm:growth:sensitiveWords:list',

  CreatorsManageList = 'crm:creators:manage:list',
  EmployeesManageList = 'crm:employees:manage:list',
  ShiftScheduleList = 'crm:shift:schedule:list',
  ShiftRecordsList = 'crm:shift:records:list',
  SettingsRoleList = 'crm:settings:role:list',

  MaintenanceCreatorEdit = 'crm:maintenance:creator:editCreator',
  MaintenanceProxyEdit = 'crm:maintenance:proxy:editProxy',
  MaintenanceProxyAdd = 'crm:maintenance:proxy:addProxy',
  MaintenanceProxyDelete = 'crm:maintenance:proxy:deleteProxy',
}
